import { useEffect } from "react";

export const useLanguage = (history, info) => {
  useEffect(() => {
    let language = history.location.pathname.substring(1);
    // remove '/' at the end
    if (language.length === 3) language = language.slice(0, -1);
    const languages = ["pt", "en", "fr", "es", "de", "it"];

    if (languages.includes(language)) info.setLanguage(language);
    else info.setLanguage("pt");
  }, []);
};
